module.exports = __webpack_public_path__ + "img/black-man.a314d5c9.jpg";